import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface SetFieldTypeParams {
  fieldId: string;
  displayName?: string;
  inUse: boolean;
  useThresh?: boolean;
  threshold?: number;
  isThresholdUpdatedByUser?: boolean;
  mandateReview?: boolean;
  reviewTags?: string[];
  tableSchema?: { key: string; displayName: string; columnPosition: number }[];
}

const setFieldType: MutationFunction<
  SetFieldTypeParams,
  SetFieldTypeParams
> = async (args) => {
  if (isMockServices()) return await mock(_mockFieldType);
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<SetFieldTypeParams>(
    `/field-types/${args.fieldId}`,
    {
      method: 'PUT',
      body: {
        ...(args.displayName !== undefined && {
          displayName: args.displayName,
        }),
        inUse: args.inUse,
        useThreshold: args.useThresh,
        threshold: args.threshold,
        isThresholdUpdatedByUser: args.isThresholdUpdatedByUser,
        mandateReview: args.mandateReview ?? false,
        reviewTags: args.reviewTags ?? [],
        tableSchema: args.tableSchema,
      },
    },
  );
  if (response.data) return response.data;
  throw new Error('Failed to set field type');
};

export default setFieldType;

const _mockFieldType = {
  fieldId: 'mock-field-id',
  name: 'mock-field-name',
  displayName: 'mock-field-display-name',
  type: 'mock-field-type',
  inUse: true,
  tableSchema: [],
};
